import React, { Component } from 'react';
import * as GlobalActions from '../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SelectionCard from '../LandingPageNew/LandingSubComponents/SelectionCard';
import view, { borders, formView, propertyType, validation } from '../../Enums';
import { NavLink } from 'react-router-dom';
import { Event } from '../LandingPageNew/Tracking/Track';

class FormHotel2 extends Component {
  componentDidMount() {
    Event(
      'Partner Page Step 2 form - Hotel',
      'Step 2 hotel form page viewed',
      '',
      ''
    );
  }

  state = {
    propertyBorder: borders.NORMAL_BORDER,
    emailBorder: borders.NORMAL_BORDER,
    adressBorder: borders.NORMAL_BORDER,
    roomBorder: borders.NORMAL_BORDER
  };
  render() {
    let gc = this.props.getContent;
    let guc = this.props.getUniversalContent;
    let gs = this.props.getStyle;
    let gi = this.props.getImage;

    return (
      <React.Fragment>
        {this.props.globalData.form_translations && (
          <div
            style={{
              height: this.props.screenheight - 80 + 'px',
              overflow: this.props.viewMode == view.MOBILE ? 'scroll' : 'scroll'
            }}
          >
            <div>
              {this.props.viewMode == view.DESKTOP && (
                <NavLink
                  exact
                  to={
                    this.props.globalData.locale
                      ? '/' + this.props.globalData.locale
                      : '/'
                  }
                  style={{ textDecoration: 'none', color: '#ffffff' }}
                >
                  <img src={gi('OYO_WHITE')} style={gs('form1_icon')} />
                </NavLink>
              )}
              <div>
                <div style={gs('text_div_form_one')}>
                  <span style={gs('form1_step_one_text')}>{gc('step_2')}</span>
                  <span style={gs('form1_step_two_text')}>
                    {' ' + gc('of_2')}
                  </span>

                  <div style={gs('lets_start_contact')}>
                    {gc('tell_us_more')}
                  </div>
                  <div style={gs('all_communications_with')}>
                    {gc('all_communications_with')}
                  </div>
                </div>
                <div style={gs('type_of_property_parent')}>
                  <div style={gs('input_label_form')}>
                    {gc('formstep1_typeOfProperty')}
                  </div>

                  <div style={gs('type_of_property_flex_parent')}>
                    <SelectionCard
                      width={'48%'}
                      height={'56px'}
                      viewMode={this.props.viewMode}
                      selected={
                        this.props.globalData.type_of_property ===
                        propertyType.HOTEL
                      }
                      info_icon={gi('info_icon')}
                      type_icon={gi('hotel_icon')}
                      tick={gi('green_tick')}
                      type_text={gc('Hotel')}
                      type_style_tag={'hotel_icon'}
                      onClick={() => {
                        this.props.globalActions.updatePropertyType(
                          propertyType.HOTEL
                        );
                      }}
                    />

                    <SelectionCard
                      width={'48%'}
                      height={'56px'}
                      viewMode={this.props.viewMode}
                      selected={
                        this.props.globalData.type_of_property ===
                        propertyType.HOME
                      }
                      info_icon={gi('info_icon')}
                      type_icon={gi('house_icon')}
                      tick={gi('green_tick')}
                      type_text={gc('Home')}
                      type_style_tag={'house_icon'}
                      onClick={() => {
                        this.props.switchFormTwoView(formView.STEP_TWO_HOME);
                        this.props.globalActions.updatePropertyType(
                          propertyType.HOME
                        );
                      }}
                    />
                  </div>
                </div>
                <div style={gs('form1_input_parent')}>
                  <div style={gs('input_label_form')}>
                    {gc('formHome_propertyName')}
                  </div>
                  <input
                    className="hideArrow mobile"
                    style={{
                      ...gs('form1_input'),
                      border: this.props.hotelBorderPropertyValidated
                        ? this.state.propertyBorder
                        : borders.RED_BORDER
                    }}
                    placeholder={gc('formHome_propertyName_placeholder')}
                    type="text"
                    required
                    autoComplete="new-password"
                    value={
                      this.props.globalData.formData
                        ? this.props.globalData.formData.hotel_name
                        : ''
                    }
                    onChange={e => {
                      this.props.validate(
                        e.target.value,
                        validation.HOTEL_PROPERTY_NAME
                      );
                      this.props.globalActions.dataUpdate(
                        'hotel_name',
                        e.target.value
                      );
                      Event(
                        'Partner Page Step 2 form - Hotel',
                        'Property name entered on Step 2 hotel form page',
                        '',
                        ''
                      );
                    }}
                    onFocus={event => {
                      this.setState({
                        propertyBorder: borders.ACTIVE_BORDER
                      });
                    }}
                    onBlur={event => {
                      this.setState({
                        propertyBorder: borders.NORMAL_BORDER
                      });
                    }}
                  />
                </div>
                <div style={gs('form1_input_parent')}>
                  <div style={gs('input_label_form')}>
                    {gc('formHome_Email')}
                  </div>
                  <input
                    className="hideArrow mobile"
                    style={{
                      ...gs('form1_input'),
                      border: this.props.hotelBorderEmail
                        ? this.state.emailBorder
                        : borders.RED_BORDER
                    }}
                    placeholder={gc('formHome_Email_placeholder')}
                    type="text"
                    required
                    autoComplete="new-password"
                    value={
                      this.props.globalData.formData
                        ? this.props.globalData.formData.email_address
                        : ''
                    }
                    onChange={e => {
                      this.props.validate(
                        e.target.value,
                        validation.HOTEL_EMAIL
                      );
                      this.props.globalActions.dataUpdate(
                        'email_address',
                        e.target.value
                      );
                      Event(
                        'Partner Page Step 2 form - Hotel',
                        'E-mail address entered on Step 2 hotel form page',
                        '',
                        ''
                      );
                    }}
                    onFocus={event => {
                      this.setState({
                        emailBorder: borders.ACTIVE_BORDER
                      });
                    }}
                    onBlur={event => {
                      this.setState({
                        emailBorder: borders.NORMAL_BORDER
                      });
                    }}
                  />
                </div>
                <div style={gs('form1_input_parent')}>
                  <div style={gs('input_label_form')}>
                    {gc('formHotel_address')}
                  </div>
                  <input
                    className="hideArrow mobile"
                    style={{
                      ...gs('form1_input'),
                      border: this.state.adressBorder
                    }}
                    placeholder={gc('formHotel_address_placeholder')}
                    type="text"
                    required
                    autoComplete="new-password"
                    value={
                      this.props.globalData.formData
                        ? this.props.globalData.formData.hotel_address
                        : ''
                    }
                    onChange={e => {
                      this.props.globalActions.dataUpdate(
                        'hotel_address',
                        e.target.value
                      );
                      Event(
                        'Partner Page Step 2 form - Hotel',
                        'Property address entered on Step 2 hotel form page',
                        '',
                        ''
                      );
                    }}
                    onFocus={event => {
                      this.setState({
                        adressBorder: borders.ACTIVE_BORDER
                      });
                    }}
                    onBlur={event => {
                      this.setState({
                        adressBorder: borders.NORMAL_BORDER
                      });
                    }}
                  />
                </div>
                {/*// no of rooms container. working properly but removed .*/}
                {/*<div style={gs('form1_input_parent')}>*/}
                {/*  <div style={gs('input_label_form')}>*/}
                {/*    {gc('formHotel_rooms')}*/}
                {/*  </div>*/}
                {/*  <input*/}
                {/*    className="hideArrow mobile"*/}
                {/*    style={{*/}
                {/*      ...gs('form1_input'),*/}
                {/*      border: this.state.roomBorder*/}
                {/*    }}*/}
                {/*    placeholder={gc('formHotel_rooms_placeholder')}*/}
                {/*    type="text"*/}
                {/*    required*/}
                {/*    autoComplete="new-password"*/}
                {/*    value={*/}
                {/*      this.props.globalData*/}
                {/*        ? this.props.globalData.number_of_rooms*/}
                {/*        : ''*/}
                {/*    }*/}
                {/*    onChange={e => {*/}
                {/*      if (*/}
                {/*        !isNaN(e.target.value) &&*/}
                {/*        e.target.value.length <= 3*/}
                {/*      ) {*/}
                {/*        console.log('data updating');*/}
                {/*        this.props.globalActions.updateNumberOfRooms(*/}
                {/*          e.target.value*/}
                {/*        );*/}
                {/*      }*/}
                {/*      Event(*/}
                {/*        'Partner Page Step 2 form - Hotel',*/}
                {/*        'No. of rooms entered on Step 2 hotel form page',*/}
                {/*        'No. of rooms',*/}
                {/*        this.props.globalData.number_of_rooms*/}
                {/*      );*/}
                {/*    }}*/}
                {/*    onFocus={event => {*/}
                {/*      this.setState({*/}
                {/*        roomBorder: borders.ACTIVE_BORDER*/}
                {/*      });*/}
                {/*      event.target.style.border = borders.ACTIVE_BORDER;*/}
                {/*    }}*/}
                {/*    onBlur={event => {*/}
                {/*      this.setState({*/}
                {/*        roomBorder: borders.NORMAL_BORDER*/}
                {/*      });*/}
                {/*    }}*/}
                {/*  />*/}
                {/*</div>*/}
              </div>

              <div style={gs('button_parent_form')}>
                {this.props.viewMode == view.DESKTOP && (
                  <div
                    onClick={() => {
                      this.props.backToStepOne();
                      Event(
                        'Partner Page Step 2 form - Hotel',
                        'Back button clicked on Step 2 hotel form page',
                        '',
                        ''
                      );
                    }}
                    style={gs('button_left_form')}
                    className={'hover'}
                  >
                    <span style={gs('button_left_form_text')}>
                      <img
                        style={{
                          position: 'relative',
                          top: '2px',
                          marginRight: '8px'
                        }}
                        src={gi('gray_arrow_left')}
                      />
                      {gc('back_to_step_1')}
                    </span>
                  </div>
                )}

                <div
                  onClick={this.props.validateCurrentForm}
                  style={gs('button_right_form')}
                  className={'hoverColor'}
                >
                  <span
                    className={'noselect'}
                    style={gs('button_right_form_text')}
                  >
                    {guc('next_step')}
                    <img
                      style={{
                        marginLeft: '8px',
                        position: 'relative',
                        top: '2px'
                      }}
                      src={gi('white_arrow_right')}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormHotel2);
